import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../../store/hooks";

export const LeadModalUserContactDataForm = () => {
    const codes = useAppSelector((state) => state.variables.data?.country_codes);

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <InputField name="email" placeholder="E-mail" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT} />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../../store/hooks";

export const LeadModalUserContactDataForm = () => {
    const codes = useAppSelector((state) => state.variables.data?.country_codes);

    return (
        <div className={userDataWrapper}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_NAME_INPUT} />
            <InputField name="email" placeholder="E-mail" dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_EMAIL_INPUT} />
            <PhoneFieldControlled
                name="phone"
                codes={codes ?? []}
                placeholder="Numer telefonu"
                maxMenuHeight={200}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.FORM_PHONE_INPUT}
            />
        </div>
    );
};

const userDataWrapper = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});
